/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const CreateCommentTask = styled.div({
  maxWidth: `${gridSize() * 110}px`,
});

export const EditCommentTask = styled.div({
  maxWidth: `${gridSize() * 110}px`,
});

export const EditCommentFieldWrapper = styled.div({
  flexGrow: 1,
});
